<template>
  <div class="product-actions__buy-quantity">
    <div class="product-quantity product-quantity--border">
      <button class="product-quantity__button product-quantity__button--minus" @click="decreaseQuantity"></button>

      <input
        ref="quantity"
        v-model.number="quantity"
        class="product-quantity__input"
        step="1"
        max="999"
        min="1"
        maxlength="3"
        minlength="1"
        @keypress="preventDecimal($event)"
        @keyup.enter="addQuantityToCartLocal()"
        @focus="selectInputValue()">

      <button class="product-quantity__button product-quantity__button--plus" @click="increaseQuantity"></button>
    </div>

    <div class="product-actions__actions-wrapper">
      <oie-base-button
        v-element-loader="{ endpoint: 'cart/addToCart' }"
        :css-classes="['button--with-border', 'button--green', 'product-actions__buy-button']"
        :text="tStatic('addToCartButtonLabel')"
        :disabled="hasNoPrice || commentRequired || !enableAddToCartButton(clientModel.currentProduct.items[0])"
        @click="addQuantityToCartLocal()">
      </oie-base-button>

      <oie-add-to-shopping-list-slide-in :product="clientModel.currentProduct"></oie-add-to-shopping-list-slide-in>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import gtm from '@/core/enhanced-ecommerce-gtm'
import { hasEmptyComments, mandatoryComments } from '@/store/mandatory-comments'

export default {
  props: {
    priceModel: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    quantity: 1,
    min: 1,
    max: 10000
  }),
  computed: {
    ...mapGetters(['enableGtm', 'longDeliveryTimeLeadTime']),
    hasNoPrice() {
      return this.priceModel.customerPrice === null || this.priceModel.customerPrice === undefined || this.priceModel.customerPrice === 0
    },
    commentRequired() {
      return this.clientModel.mandatoryComment && hasEmptyComments()
    }
  },
  watch: {
    quantity() {
      if(this.quantity < this.min) {
        this.quantity = this.min
      } else if(this.quantity > this.max) {
        this.quantity = this.max
      }
    }
  },
  methods: {
    ...mapActions('commerce', ['addToCart']),
    addQuantityToCartLocal() {
      this.addToCart({
        itemId: this.clientModel.selectedItem,
        productId: this.clientModel.currentProduct.id,
        purchasedOnCategory: this.clientModel.analyticsCategory,
        quantity: this.quantity,
        purchasedToVehicle: this.clientModel.analyticsVehicle,
        mandatoryComments: mandatoryComments()
      }).then((data) => {
        if (this.enableGtm && data.cart) {
          const addedProduct = data.cart.rows.find(x => (x.itemId === this.clientModel.selectedItem) && (x.productId === this.clientModel.currentProduct.id))

          const gtmObject = gtm.createGtmItem(
            addedProduct.itemId,
            addedProduct.displayName,
            addedProduct.item.purchasedToVehicle,
            addedProduct.item.purchasedOnCategory,
            this.formatPriceWithoutCurrency(addedProduct.priceExVat),
            addedProduct.quantity,
            '')

          gtm.addToCart(gtmObject)
        }
      })
    },
    preventDecimal(event) {
      if (event.key === '.' || event.key === ',') {
        event.preventDefault()
      }
    },
    increaseQuantity() {
      this.quantity += 1
    },
    decreaseQuantity() {
      this.quantity -= 1
    },
    selectInputValue() {
      this.$refs.quantity.setSelectionRange(0, this.$refs.quantity.value.length)
    },
    getStockStatus(item) {
      var number = item.stock
      var threshold = this.getProductFewInStock()
      if (number === undefined) { number = 0 }
      if (threshold === undefined) { threshold = 0 }
      if (number >= threshold) {
        return 'in-stock'
      } else if (number > 0) {
        return 'few-stock'
      } else if (item.isOrderItem) {
        return 'is-order-item'
      } else {
        return 'no-stock'
      }
    },
    enableAddToCartButton(item) {
      if (this.getStockStatus(item) === 'no-stock' && item.deliveryTime && item.deliveryDate.startsWith('2030-01-01') && item.deliveryTime >= this.longDeliveryTimeLeadTime) {
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss">
.product-actions__actions-wrapper {
  display: flex;
  gap: measure(quarter);
  align-items: center;
}
</style>
